"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var paymentSummaryStyles_1 = require("./paymentSummaryStyles");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var PaymentSummary = function (_a) {
    var summary = _a.summary;
    var styles = paymentSummaryStyles_1.default({ summary: summary });
    var paymentTransactionLabel = function () { return (<>
      <icons_1.LockRounded className={styles.icon}/>
      <Translation_1.default className={styles.transactionLabel} id="trans__checkout__next_step__payment_page__transaction_label"/>
    </>); };
    return (<core_1.Box className={styles.container} data-test="online_order:disclaimer_transaction_label">
      {summary ? (paymentTransactionLabel()) : (<core_1.Typography className={styles.transactionLabelContainer}>{paymentTransactionLabel()}</core_1.Typography>)}
    </core_1.Box>);
};
exports.default = PaymentSummary;
